
export const LAYOUT = {
    TOPBAR_HEIGHT: 60,
    SIDEBAR_WIDTH: 240,
    SIDEBAR_WIDTH_COLLAPSED: 60,
    MENU_ITEM_HEIGHT: 50,
    MENU_SUBITEM_HEIGHT: 40,
};